import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { PrivateLayoutProvider, usePrivateLayoutState } from './context/privateLayoutContext';
import PrivateLayout from './PrivateLayout';
import { isMobileAdaptiveSelector, showMenuSelector } from './context/privateLayoutSelector';
import { privateRoutes } from '../../routes/routesConstants';

export const PrivateLayoutContainer = () => {
  const state = usePrivateLayoutState();
  const showMenu = showMenuSelector(state);
  const isMobileAdaptive = isMobileAdaptiveSelector(state);
  const navigate = useNavigate();

  return (
    <PrivateLayout
      showMenu={showMenu}
      isMobileAdaptive={isMobileAdaptive}
      onHomeClick={useCallback(() => {
        navigate(privateRoutes.home);
      }, [navigate])}
    />
  );
};

type Props = {
  showMenu: boolean;
  isMobileAdaptive: boolean;
};

export const PrivateLayoutWrapper: FC<Props> = ({ showMenu = true, isMobileAdaptive = false }) => (
  <PrivateLayoutProvider state={{ showMenu, isMobileAdaptive }}>
    <PrivateLayoutContainer />
  </PrivateLayoutProvider>
);

export default PrivateLayoutContainer;
